import { render, staticRenderFns } from "./ScoutTabMenu.vue?vue&type=template&id=1773c3ba"
import script from "./ScoutTabMenu.vue?vue&type=script&lang=js"
export * from "./ScoutTabMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports